import { WorkspacePlan } from '@up2stay/up2promo-api-client';

import {
  FEATURE_KEYS,
  FEATURE_MINIMUM_PLAN,
  type FeatureKey,
} from '@/core/authz/entitlement-catalog';
import { shellPaths } from '@/core/router/app-paths';

const FEATURE_PARAM = 'feature';

/**
 * Plans page link that remembers which locked feature sent the user there.
 * Without it every upsell landed on „Empfohlen: Plus“, even for Teams-only
 * features like events or invitations (DEV-575).
 */
export function billingUpgradePath(feature?: FeatureKey | null): string {
  if (!feature) return shellPaths.moreWorkspaceBillingUpgrade;
  const query = new URLSearchParams({ [FEATURE_PARAM]: feature });
  return `${shellPaths.moreWorkspaceBillingUpgrade}?${query.toString()}`;
}

export function readUpgradeFocusFeature(search: string): FeatureKey | null {
  const value = new URLSearchParams(search).get(FEATURE_PARAM);
  return value && (FEATURE_KEYS as readonly string[]).includes(value)
    ? (value as FeatureKey)
    : null;
}

/** Plan the plans page recommends: the focus feature's plan, else Plus. */
export function recommendedUpgradePlan(
  feature: FeatureKey | null,
): WorkspacePlan {
  return feature ? FEATURE_MINIMUM_PLAN[feature] : WorkspacePlan.PLUS;
}
